import {balanceEntries, fetchBalance, worstStatus} from "../helpers/sncr";

export default {
    namespaced: true,
    state: {
        balance: null,
        professionalId: null,
        loading: false,
    },
    mutations: {
        setBalance(state, {balance, professionalId}) {
            state.balance = balance;
            state.professionalId = professionalId;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        clear(state) {
            state.balance = null;
            state.professionalId = null;
            state.loading = false;
        },
    },
    actions: {
        load({commit, state}, {professionalId, force = false}) {
            if (!professionalId) {
                return Promise.resolve(null);
            }

            if (!force && state.balance && state.professionalId === professionalId) {
                return Promise.resolve(state.balance);
            }

            commit('setLoading', true);

            return fetchBalance(professionalId).then((balance) => {
                commit('setBalance', {balance, professionalId});
                return balance;
            }).catch(() => {
                return null;
            }).finally(() => {
                commit('setLoading', false);
            });
        },
        apply({commit}, {balance, professionalId}) {
            commit('setBalance', {balance, professionalId});
        },
    },
    getters: {
        entries(state) {
            return balanceEntries(state.balance);
        },
        hasData(state, getters) {
            return getters.entries.length > 0;
        },
        worst(state, getters) {
            return worstStatus(getters.entries.map((entry) => entry.status));
        },
        attention(state, getters) {
            return getters.entries.filter((entry) => entry.status !== 'COMFORTABLE');
        },
    },
}
